import numeral from 'numeral'

export default function formatCurrency(value) {
  return value < 10 ? '0.00 a' : '0.[00] a'
}

export function withNumeral(value) {
  return numeral(value).format(formatCurrency(value))
}

export function thousandSeparator(value) {
  return numeral(value).format('0,0')
}
